/** Zeigertyp-Prüfung: `true` für Finger und Stift, `false` für die Maus (und Ereignisse ohne `pointerType`). */
export const isTouchLike = (event) => event.pointerType !== undefined && event.pointerType !== 'mouse';
